import axios from 'axios';

const searchCards = async (siteId, search) => {
    try {
        const resp = await axios.get(`/api/search/${siteId}?query=${search}`);
        return resp;
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
};

export default {
    searchCards
}